import { IconButton, IconButtonProps, styled } from '@mui/material';
import { ReactNode } from 'react';
import { AvatarIcon } from '../..';

interface BrightyIconButtonProps extends IconButtonProps {
  icon: ReactNode;
  label: string;
}

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  flexDirection: 'column',
  fontSize: '0.75rem',
  color: theme.palette.text.secondary,
  gap: 4,
  borderRadius: 8,
  '&:hover': {
    backgroundColor: theme.palette.surface.secondary,
  },
}));

export function BrightyIconButton({ icon, label, ...props }: BrightyIconButtonProps) {
  return (
    <StyledIconButton {...props}>
      <AvatarIcon icon={icon} />
      {label}
    </StyledIconButton>
  );
}
